<template>
  <div class="section text-left">
    <h3 class="sr-only">Subscription Details</h3>
    <dl class="padding-left-0">
      <dt class="display-inline-block">Subscription ID:</dt>
      <dd class="display-inline-block margin-bottom-0">{{ id }}</dd>

      <dt class="sr-only">Email associated with subscription</dt>
      <dd style="overflow-wrap: break-word">{{ email }}</dd>
    </dl>
  </div>
</template>

<script>
  import get from 'lodash/get'

  export default {
    name: 'SubscriptionDetails',

    props: {
      subscription: {
        type: Object
      }
    },

    computed: {
      id() {
        return get(this.subscription, ['shortDerivedId'])
      },

      email() {
        return get(this.subscription, ['account', 'email']) || get(this.$account, ['email'])
      }
    }
  }
</script>
